import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "operators" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "emq-table-footer" }

import { getProfitsharingStrategyAuthList, delProfitsharingStrategyAuth } from '@/api/operation'
import { dateFormat } from '@/common/tools'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { Refresh, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import StrategyAuthAdd from './StrategyAuthAdd.vue'
import { Ref } from 'vue'
import { checkMenuShow } from '@/store/tool'

import { ElMessage, ElMessageBox } from 'element-plus'


import { defineComponent, ref } from 'vue'

const __default__ = defineComponent({
  name: 'StrategyAuth',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  strategyID: {
    type: String,
    required: true,
  },
  operatorID: {
    type: String,
    required: true,
  },
  enable: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Operation')
const { getAdoType } = useProtocolEnums()



const showDialog = ref(false)
const showMoreQuery = ref(false)
const showIsEdit = ref(false)
const showInfo: Ref<undefined | Record<string, any>> = ref(undefined)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')

const auth = () => {
  showDialog.value = true
  showInfo.value = undefined
  showIsEdit.value = false
}

const unauth = async (info: any) => {
  await ElMessageBox.confirm(t('Operation.unauthAdoConfirm'), {
    confirmButtonText: t('Base.confirm'),
    cancelButtonText: t('Base.cancel'),
    confirmButtonClass: 'confirm-danger',
    type: 'warning',
  })
  try {
    await delProfitsharingStrategyAuth({
      authId: info.id,
    })
    ElMessage.success(t('Base.deleteSuccess'))
    loadTableData()
  } catch (error) {
    console.log(error)
  }
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { strategyId, name, operatorId } = params
  newParams = {
    strategyId: strategyId || undefined,
    name: name || undefined,
    operatorId: operatorId || undefined,
  }
  return newParams
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
    strategyId: props.strategyID,
    enable: props.enable,
  }

  try {
    const { list = [], pageReply = {} } = await getProfitsharingStrategyAuthList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

loadTableData()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (auth()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.use')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'strategyAuthAdd']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: loadTableData
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "bindFlagType",
            "min-width": "80",
            label: _ctx.$t('Operation.authado'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(PreWithEllipsis, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getAdoType)(row.bindFlagType)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "name",
            "min-width": "80",
            label: _ctx.$t('Base.name'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                content: row.bindFlagId,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(PreWithEllipsis, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.bindFlagName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            "min-width": "100",
            label: _ctx.$t('Base.usedAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (unauth(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'strategyAuthDelete']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTableData
        }, null, 8, ["metaData"])
      ]),
      _createVNode(StrategyAuthAdd, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
        strategyID: props.strategyID,
        operatorID: props.operatorID,
        onSubmitted: loadTableData
      }, null, 8, ["modelValue", "strategyID", "operatorID"])
    ])
  ]))
}
}

})